export default __webpack_public_path__ + "static/media/m-check.46155197.svg";